export default __webpack_public_path__ + "static/AcidGrotesk-Regular-5ab875a8f314a9483b0dab482f2322d5.eot";